module.exports = __webpack_public_path__ + "img/logo-microsite.2071995e.png";